<template>
  <q-list bordered separator>
    <q-expansion-item
      expand-separator
      label="My Lists"
      group="filters"
      :icon="isPremium ? 'list' : 'lock'"
      :dense="denseFilter"
      :disable="!isPremium"
    >
      <q-card>
        <q-card-section>
          <q-item tag="label" :dense="denseFilter">
            <q-item-section>
              <q-item-label
                >Wishlist ({{ wishlistCourseIds.length }})</q-item-label
              >
            </q-item-section>
            <q-item-section avatar>
              <q-toggle
                :dense="denseFilter"
                :value="wishlistOnly"
                :disable="isFilteringList && !wishlistOnly"
                @input="setWishlistOnly"
              />
            </q-item-section>
          </q-item>
          <q-item tag="label" :dense="denseFilter">
            <q-item-section>
              <q-item-label
                >Played ({{ coursePlayedCourseIds.length }})</q-item-label
              >
            </q-item-section>
            <q-item-section avatar>
              <q-toggle
                :dense="denseFilter"
                :value="coursePlayedOnly"
                :disable="isFilteringList && !coursePlayedOnly"
                @input="setCoursePlayedOnly"
              />
            </q-item-section>
          </q-item>
          <q-item tag="label" :dense="denseFilter">
            <q-item-section>
              <q-item-label
                >Rated ({{ userCourseReviewsCourseIds.length }})</q-item-label
              >
            </q-item-section>
            <q-item-section avatar>
              <q-toggle
                :dense="denseFilter"
                :value="ratedOnly"
                :disable="isFilteringList && !ratedOnly"
                @input="setRatedOnly"
              />
            </q-item-section>
          </q-item>
          <q-item tag="label" :dense="denseFilter">
            <q-item-section>
              <q-item-label
                >Notes ({{ userCourseNotesCourseIds.length }})</q-item-label
              >
            </q-item-section>
            <q-item-section avatar>
              <q-toggle
                :dense="denseFilter"
                :value="notesOnly"
                :disable="isFilteringList && !notesOnly"
                @input="setNotesOnly"
              />
            </q-item-section>
          </q-item>
          <q-separator />
          <q-item tag="label" :dense="denseFilter" :inset-level="0.1">
            <q-item-section>
              <q-item-label>Preferred Country</q-item-label>
              <q-item-label caption>{{ preferredCountryLabel }}</q-item-label>
            </q-item-section>
            <q-item-section avatar>
              <q-toggle
                :dense="denseFilter"
                :value="preferredCountryOnly"
                :disable="!isFilteringList || internationalOnly"
                @input="setPreferredCountryOnly"
              />
            </q-item-section>
          </q-item>
          <q-item tag="label" :dense="denseFilter" :inset-level="0.1">
            <q-item-section>
              <q-item-label>International</q-item-label>
            </q-item-section>
            <q-item-section avatar>
              <q-toggle
                :dense="denseFilter"
                :value="internationalOnly"
                :disable="!isFilteringList || preferredCountryOnly"
                @input="setInternationalOnly"
              />
            </q-item-section>
          </q-item>
        </q-card-section>
      </q-card>
    </q-expansion-item>
    <q-expansion-item
      :key="index"
      :label="category"
      expand-separator
      group="filters"
      v-for="(category, index) in filterCategories"
      :icon="filterDatapointsGroupedByCategory[category][0].categoryIcon"
      :dense="denseFilter"
      :class="{
        'bg-light-blue-1': filterCategoriesWithActiveFilters.includes(category),
      }"
    >
      <q-card>
        <q-card-section
          v-for="dp in filterDatapointsGroupedByCategory[category]"
          :key="dp.id"
        >
          <q-tooltip
            max-width="250px"
            content-style="font-size: 12px;"
            anchor="top middle"
            self="bottom middle"
            :delay="1000"
            :offset="[0, 0]"
            v-if="dp.filterType === 'date_added'"
          >
            {{ recentlyAddedDescription }}
          </q-tooltip>
          <q-tooltip
            max-width="250px"
            content-style="font-size: 12px;"
            anchor="top middle"
            self="bottom middle"
            :delay="1000"
            :offset="[0, 0]"
            v-else
          >
            {{ dp.description }}
          </q-tooltip>

          <template v-if="dp.filterType === 'autocomplete'">
            <AutocompleteChild
              v-if="dp.id === 'OLGDP023'"
              :id="dp.id"
              :label="dp.label"
              :items="dp.allItems"
              :dense="denseFilter"
              :filter="dp.filter"
              parent-id="OLGDP101"
              @update="updateFilterInput"
            />
            <Autocomplete
              v-else
              :id="dp.id"
              :label="dp.label"
              :items="dp.allItems"
              :dense="denseFilter"
              :filter="dp.filter"
              @update="updateFilterInput"
            />
          </template>
          <template v-else-if="dp.filterType === 'checkboxlist'">
            <CheckboxList
              :id="dp.id"
              :label="dp.label"
              :description="dp.definition"
              :items="dp.allItems"
              :dense="denseFilter"
              :filter="dp.filter"
              @update="updateFilterInput"
            />
          </template>
          <template v-else-if="dp.filterType === 'range'">
            <Range
              :id="dp.id"
              :label="dp.label"
              :items="dp.allItems"
              :dense="denseFilter"
              :filter="dp.filter"
              @update="updateFilterInput"
            />
          </template>
          <template v-else-if="dp.filterType === 'rating_range'">
            <RatingRange
              :id="dp.id"
              :label="dp.label"
              :items="dp.allItems"
              :dense="denseFilter"
              :filter="dp.filter"
              @update="updateFilterInput"
            />
          </template>
        </q-card-section>
      </q-card>
    </q-expansion-item>
    <q-expansion-item
      expand-separator
      label="Weather"
      group="filters"
      :icon="isPremium ? 'thermostat' : 'lock'"
      :dense="denseFilter"
      :class="{
        'bg-light-blue-1': weatherFilterInput,
      }"
      :disable="!isPremium"
    >
      <q-card>
        <q-card-section>
          <q-tooltip
            max-width="250px"
            content-style="font-size: 12px;"
            anchor="top middle"
            self="bottom middle"
            :delay="1000"
            :offset="[0, 0]"
          >
            Historical average temperature for the month based on the most
            recent National Oceanic and Atmospheric Administration (NOAA)
            Climate Normals. Normals are calculated for a uniform 30 year period
            from almost 15,000 weather stations across the U.S.
          </q-tooltip>
          <WeatherFilter
            :weather-filter-input="weatherFilterInput"
            @update="updateWeatherFilterInput"
          ></WeatherFilter>
        </q-card-section>
      </q-card>
    </q-expansion-item>
    <q-item v-if="filterInput.length || weatherFilterInput || recentlyAdded">
      <q-item-section>
        <FilterBar @reset="reset" />
      </q-item-section>
    </q-item>
  </q-list>
</template>
<script>
import { mapGetters, mapState } from "vuex";
import Autocomplete from "@/components/filters/Autocomplete.vue";
import AutocompleteChild from "@/components/filters/AutocompleteChild.vue";
import CheckboxList from "@/components/filters/CheckboxList.vue";
import Range from "@/components/filters/Range.vue";
import RatingRange from "@/components/filters/RatingRange.vue";
import WeatherFilter from "@/components/filters/Weather.vue";
import FilterBar from "@/components/FilterBar.vue";
import { getNormalsZipsByMonthAndTempRange } from "@/apis/weather-service";
import { DEFAULT_COUNTRY, RECENTLY_ADDED_THRESHOLD_DAYS } from "@/constants";
import COUNTRIES from "@/data/countries.json";

export default {
  name: "Filters",
  components: {
    Autocomplete,
    AutocompleteChild,
    CheckboxList,
    Range,
    RatingRange,
    FilterBar,
    WeatherFilter,
  },
  data() {
    return {
      recentlyAddedDescription: `Courses added in the past ${RECENTLY_ADDED_THRESHOLD_DAYS} days`,
    };
  },
  beforeCreate() {},
  computed: {
    ...mapGetters([
      "isPremium",
      "wishlistCourseIds",
      "coursePlayedCourseIds",
      "filterDatapoints",
      "filterCategories",
      "filterDatapointsGroupedByCategory",
      "filterCategoriesWithActiveFilters",
      "filteredCourses",
      "listViewColumnsConfig",
      "preferredCountry",
    ]),
    ...mapState([
      "courses",
      "filterInput",
      "filterColumns",
      "wishlistOnly",
      "coursePlayedOnly",
      "denseFilter",
      "idToken",
      "weatherFilterInput",
      "notesOnly",
      "ratedOnly",
      "recentlyAdded",
      "preferredCountryOnly",
      "internationalOnly",
      "userCourseNotesCourseIds",
      "userCourseReviewsCourseIds",
    ]),
    isFilteringList() {
      return (
        this.wishlistOnly ||
        this.coursePlayedOnly ||
        this.notesOnly ||
        this.ratedOnly ||
        this.preferredCountryOnly ||
        this.internationalOnly
      );
    },
    preferredCountryLabel() {
      const code = this.preferredCountry || DEFAULT_COUNTRY;
      const country = COUNTRIES.find(c => c.code === code);

      return country.name;
    },
  },
  mounted() {
    this.$root.$on("reset-filter-input", () => {
      console.debug("reset-filter-input in filters");

      this.reset(true);
    });
  },
  methods: {
    updateFilterInput(id, selectedItems) {
      const meta = this.filterDatapoints.find(dp => dp.id === id);
      const newFilterInput = this.filterInput.slice(0);
      const newFilterItem = {
        id,
        filter: selectedItems,
        type: meta.filterType,
        label: meta.label,
      };

      const existingIndex = newFilterInput.findIndex(f => f.id === id);

      if (existingIndex >= 0) {
        const isRange =
          newFilterItem.type === "range" ||
          newFilterItem.type === "rating_range";
        let shouldRemoveRange = false;

        if (isRange) {
          const { min, max } = meta;

          shouldRemoveRange =
            selectedItems.min === min && selectedItems.max === max;
        }

        if (selectedItems.length === 0 || shouldRemoveRange) {
          newFilterInput.splice(existingIndex, 1);
        } else {
          newFilterInput.splice(existingIndex, 1, newFilterItem);
        }
      } else {
        newFilterInput.push(newFilterItem);
      }

      this.$store.commit("setFilterInput", newFilterInput);
    },
    close() {
      this.$emit("close");
    },
    reset(quiet = false) {
      this.$store.commit("setRecentlyAdded", false);

      if (quiet) {
        return;
      }

      this.$root.$emit("reset-filter-input");
    },
    setWishlistOnly(val) {
      this.$nextTick(() => {
        if (!val && this.preferredCountryOnly) {
          this.setPreferredCountryOnly(val);
        } else if (!val && this.internationalOnly) {
          this.setInternationalOnly(val);
        }

        this.$store.commit("setWishlistOnly", val);
      });
    },
    setCoursePlayedOnly(val) {
      this.$nextTick(() => {
        if (!val && this.preferredCountryOnly) {
          this.setPreferredCountryOnly(val);
        } else if (!val && this.internationalOnly) {
          this.setInternationalOnly(val);
        }

        this.$store.commit("setCoursePlayedOnly", val);
      });
    },
    setNotesOnly(val) {
      this.$nextTick(() => {
        if (!val && this.preferredCountryOnly) {
          this.setPreferredCountryOnly(val);
        } else if (!val && this.internationalOnly) {
          this.setInternationalOnly(val);
        }

        this.$store.commit("setNotesOnly", val);
      });
    },
    setRatedOnly(val) {
      this.$nextTick(() => {
        if (!val && this.preferredCountryOnly) {
          this.setPreferredCountryOnly(val);
        } else if (!val && this.internationalOnly) {
          this.setInternationalOnly(val);
        }

        this.$store.commit("setRatedOnly", val);
      });
    },
    setRecentlyAdded(val) {
      this.$nextTick(() => this.$store.commit("setRecentlyAdded", val));
    },
    setPreferredCountryOnly(val) {
      this.$nextTick(() => this.$store.commit("setPreferredCountryOnly", val));
    },
    setInternationalOnly(val) {
      this.$nextTick(() => this.$store.commit("setInternationalOnly", val));
    },
    updateWeatherFilterInput(val) {
      if (!val) {
        this.$store.commit("setWeatherFilterInput", null);
        this.$store.commit("setWeatherFilterZips", null);

        return;
      }

      const { shortMonth, queryStringRangePairs } = val;

      this.$store.commit("setWeatherFilterInput", val);
      this.$store.commit("setIsLoading", true);

      this.fetchWeatherNormalsZipsByMonthAndTempRange(
        shortMonth,
        queryStringRangePairs,
      ).then(zips => {
        this.$store.commit("setWeatherFilterZips", zips);
        this.$store.commit("setIsLoading", false);
      });
    },
    fetchWeatherNormalsZipsByMonthAndTempRange(month, temps) {
      const token = this.idToken;

      return getNormalsZipsByMonthAndTempRange(token, month, temps).then(
        result => {
          const zips = result.map(r => r.zip);

          return zips;
        },
      );
    },
  },
  watch: {},
};
</script>
<style lang="scss" scoped></style>
